var CurrentUser = require("lib/account/CurrentUser");

class OnboardingStageSelectQuizFormat extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var selectedFormat = null;
		this.state = {
			selectedFormat, orderedFormatOptions: _.shuffle(FORMAT_OPTIONS)
		};
	}

	toggleFeature(selectedFormat) {
		this.setState({ selectedFormat });
	}

	submitFeatures() {
		var adminID = CurrentUser.get().id;
		var featuresData = { feature_overrides: this.state.selectedFormat }
		var params = { admin: featuresData };
		CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler((response) => {
			CurrentUser.fetchCurrentUserData();
		}));
		this.props.onComplete(featuresData);
		Mycroft.newEvent({ category: "Onboarding", action: "format-selected" });
	}

	featureTitle(featureKey) {
		if (featureKey == FILL_IN_ONLY) {
			return "Fill-in-the-blank questions only";
		} else if (featureKey == SHORT_ANSWER_ONLY) {
			return "Short response questions only";
		} else if (featureKey == FILL_IN_AND_SHORT_ANSWER) {
			return "Both fill-in-the-blank and short response questions";
		}
	}

	renderFormatOption(formatKey) {
		var featureImagePath = "onboarding/" + formatKey + ".png";

		var className = "largeObject clickableElement";
		if (this.state.selectedFormat == formatKey) {
			className += " selectedFormat";
		}
		// Hacky, but I can't be bothered to do better for a test
		if (formatKey != FILL_IN_AND_SHORT_ANSWER) {
			className += " push";
		}

		return (
			<div className={ className } key={ formatKey }
				onClick={ this.toggleFeature.bind(this, formatKey) }>
				{ this.featureTitle(formatKey) }
			</div>
		);
	}

	renderSelectedImage() {
		var featureImagePath = "onboarding/" + this.state.selectedFormat + ".png";

		return (
			<img src={ dynamicRequire(featureImagePath) } className="formatImg" />
		);
	}

	render() {
		var formatObjects = _.map(this.state.orderedFormatOptions, (featureKey) => {
			return this.renderFormatOption(featureKey);
		});
		var formatOptions = (
			<div className="formatOptions">
				{ formatObjects }
			</div>
		);

		var mainContent = (
			<div className="singleCol">
				<p className="onboardingGreeting">
					What kinds of questions would you like on your reading quizzes?
				</p>
				<p className="onboardingInstructions">
					<span className="instructionTitle">You can always change this later.</span>
				</p>
			</div>
		);

		if (this.state.selectedFormat != null) {
			var selectedImage = this.renderSelectedImage();
			var submitButton = (
				<button className="btn buttonPrimary confirmFormat"
					onClick={ this.submitFeatures }>
					All Set
				</button>
			);
		}

		return (
			<div className="onboardingStage onboardingStageSelectQuizFormat clearfix">
				{ mainContent }
				{ formatOptions }
				{ selectedImage }
				{ submitButton }
			</div>
		);
	}
}

var FILL_IN_ONLY = "onboarding-fill-in-only";
var SHORT_ANSWER_ONLY = "onboarding-short-answer-in-only";
var FILL_IN_AND_SHORT_ANSWER = "onboarding-fill-in-and-short-answer";

var FORMAT_OPTIONS = [
	FILL_IN_ONLY, SHORT_ANSWER_ONLY, FILL_IN_AND_SHORT_ANSWER
];


OnboardingStageSelectQuizFormat.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	// only used for the final stage of onboarding
	endOnboarding: PropTypes.func,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageSelectQuizFormat;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageSelectQuizFormat.js